import script from "./esPatientMain.vue?vue&type=script&lang=ts&setup=true"
export * from "./esPatientMain.vue?vue&type=script&lang=ts&setup=true"

import "./esPatientMain.vue?vue&type=style&index=0&id=20bf4584&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20bf4584"]])

export default __exports__